import { render, staticRenderFns } from "./history-shipping-collaborator.vue?vue&type=template&id=e4bf1c3e&"
import script from "./history-shipping-collaborator.vue?vue&type=script&lang=js&"
export * from "./history-shipping-collaborator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports